import React from "react";
import { Globe2, AlertTriangle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { formatLKR } from "@/lib/api";

/**
 * Inline chip rendered next to a stock symbol when foreign flow on the most
 * recent day was significant (≥ Rs.10M).
 *  - Net BUY → globe (success tone)
 *  - Net SELL → warning triangle (destructive tone)
 */
export const ForeignFlowChip = ({ entry, size = "sm" }) => {
  if (!entry || entry.amount_lkr_mn == null) return null;
  if (entry.amount_lkr_mn < 10) return null;
  const isBuy = entry.direction === "buy";
  const Icon = isBuy ? Globe2 : AlertTriangle;
  const cls = isBuy
    ? "text-[hsl(var(--success))] bg-[hsl(var(--success))]/10 border-[hsl(var(--success))]/30"
    : "text-[hsl(var(--destructive))] bg-[hsl(var(--destructive))]/10 border-[hsl(var(--destructive))]/30";
  const label = isBuy
    ? `Foreigners net buying ${formatLKR(entry.amount_lkr_mn * 1e6, { compact: true })}`
    : `Foreigners net selling ${formatLKR(entry.amount_lkr_mn * 1e6, { compact: true })}`;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex items-center gap-0.5 rounded border px-1 ${size === "sm" ? "text-[10px] py-0" : "text-xs py-0.5"} ${cls}`}
            data-testid="foreign-flow-chip"
          >
            <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <div className="text-xs">{label}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ForeignFlowChip;
